<template>
    <div>
        <h1 class="page-title">Authentification forte</h1>
        <div style="margin: 10px 0"></div>

        <p>Activez l'authentification forte (2FA) pour plus de sécurité et pour pouvoir vous connecter au Dashboard lors de vos déplacements.</p>
        <br>
        <Button
            @click="showQrCode()"
            size="small"
            type="button"
            severity="warning"
            label="Activer/Modifier 2FA"
            aria-label="Activer/Modifier 2FA"
            icon="pi pi-lock"
        />
        
        <Dialog v-model:visible="showDialog" maximizable modal header="Activer/modifer 2FA" :style="{ width: '25rem' }">
            <span class="p-text-secondary block mb-5">Pour activer ou modifier l'authentification forte,
                scannez ce code barre avec votre application d'authentification
                (Google authenticator, Authy, Microsoft authenticator, Duo Mobile ou autres) sur votre téléphone.
            </span>
            <div class="flex align-items-center gap-3 mb-3" v-if="qrCode">
                <img :src="qrCode" alt="QR Code" style="max-width: 100%; height: auto;" />
            </div>
            <div class="flex justify-content-end gap-2">
                Si vous avez perdu votre appareil contenant l'application d'authentification
                vous pouvez récupérer les codes en scannant ce QR Code à partir de votre nouveau téléphone.
            </div>
        </Dialog>
    </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {useAuthStore} from '@/stores/auth/authStore';
import swal from "@/_helpers/swal";
import Button from "primevue/button";
import Dialog from 'primevue/dialog';

const authStore = useAuthStore();
const qrCode = ref<string | null>(null);
const showDialog = ref<boolean>(false);

onMounted(async () => {
    await enableGoogleAuthenticatorSecret();
});

const enableGoogleAuthenticatorSecret = async () => {
    try {
        await authStore.enableGoogleAuthenticatorSecret();
    } catch (error) {
        console.error(`Erreur lors de l'activation du secret de google authenticator:`, error);
    }
};

const getQrCode = async () => {
    try {
        qrCode.value = await authStore.get2FaQrCode();
    } catch (error) {
        console.error('Erreur lors de la récupération du QR code:', error);
    }
};

const showQrCode = async () => {
    try {
        await getQrCode();

        showDialog.value = true;
    } catch (error) {
        const errorMsg = 'Erreur lors de la génération du QR code.';
        swal.error(errorMsg);
    }
};

</script>

<style scoped>
img {
    max-width: 100%;
    height: auto;
}
</style>